__turbopack_context__.v({
  "logo_gradient": "Z_Logo_Gradient-module-sass-module__iRee1G__logo_gradient",
  "logo_gradient__canvas": "Z_Logo_Gradient-module-sass-module__iRee1G__logo_gradient__canvas",
});
